const RECENTLY_VIEWED_KEY = 'shopify_recently_viewed';
const MAX_RECENTLY_VIEWED = 20;

class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.handle;
    if (!handle) return;

    try {
      let handles = JSON.parse(
        localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]',
      );
      if (!Array.isArray(handles)) handles = [];

      // Remove duplicate then prepend — newest first
      handles = handles.filter((h) => h !== handle);
      handles.unshift(handle);

      localStorage.setItem(
        RECENTLY_VIEWED_KEY,
        JSON.stringify(handles.slice(0, MAX_RECENTLY_VIEWED)),
      );
    } catch {
      // localStorage unavailable (e.g. private browsing with strict settings)
    }
  }
}

if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', RecentlyViewed);
}
